
/**
 * @imports
 */
import Observer from './index.js';

// As globals
if ( !self.webqit ) { self.webqit = {}; }
self.webqit.Observer = Observer;